
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
import type { ReactNode } from "react";

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <VisuallyHiddenPrimitive.Root>{children}</VisuallyHiddenPrimitive.Root>;
}
